/* eslint-disable max-len */
import React from 'react';
import ReactDOM from 'react-dom';
import OrganizationContacts from '../../src/organization_show/organization_contacts/organization_contacts';
import OrganizationJobs from '../../src/organization_show/organization_jobs/organization_jobs';
import { initSmoothScrollSections } from '../../src/organization_show/show';
import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';
import Tooltip from 'bootstrap/js/dist/tooltip';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

/* eslint-enable max-len */

document.addEventListener('DOMContentLoaded', () => {
  const rootContacts = document.getElementById('organization_contacts');
  const rootJobs = document.getElementById('jobs-section');

  if (rootContacts) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <OrganizationContacts
          organizationName={rootContacts.getAttribute('organizationname')}
          organizationId={rootContacts.getAttribute('organizationid')}
          isAdmin={rootContacts.getAttribute('admin') === 'true'}
        />
      </DevexHighOrderComponent>,
      rootContacts
    );
  }

  if (rootJobs) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <OrganizationJobs
          orgName={rootJobs.getAttribute('orgName')}
          isSignedIn={rootJobs.getAttribute('isSignedIn') === 'true'}
          viewExclusiveJobs={rootJobs.getAttribute('viewExclusiveJobs') === 'true'}
          membership={rootJobs.getAttribute('membership')}
          isAdmin={false}
        />
      </DevexHighOrderComponent>,
      rootJobs
    );
  }

  addBackToTop(DEFAULT_SETTINGS);
  initSmoothScrollSections();

  // Script to handle expanded/collapsed organization description if it is needed
  const expandDescriptionButton = document.getElementById('expand-description-btn');
  if (expandDescriptionButton) {
    const descriptionWrapper = document.getElementById('description-wrapper');
    // If the wrapped description is taller than its 5-line container
    if (descriptionWrapper.scrollHeight > descriptionWrapper.clientHeight) {
      // Stop hiding the Read more button
      document.getElementById('expand-description-btn-container').classList.remove('d-none');
    // If the wrapped description is short enough to fit in its container
    } else {
      // Remove the fade effect on the wrapped description
      descriptionWrapper.classList.remove('wrapped-description');
    }

    // Toggle between wrapped and expanded description on button click
    expandDescriptionButton.addEventListener('click', () => {
      if (descriptionWrapper.classList.contains('wrapped-description')) {
        descriptionWrapper.classList.remove('wrapped-description');
        descriptionWrapper.classList.add('expanded-description');
        expandDescriptionButton.textContent = 'Read less';
      } else {
        descriptionWrapper.classList.add('wrapped-description');
        descriptionWrapper.classList.remove('expanded-description');
        expandDescriptionButton.textContent = 'Read more';
      }
    });
  }

  // Enable Bootstrap tooltips
  const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach((element) => new Tooltip(element));

  // Enable Bootstrap collapse offices if there are more than 3 offices
  const collapsibleContainer = document.querySelector('#collapsable-offices');
  if (collapsibleContainer) {
    const collapsibleButtonSpan = document.querySelector('.show-more-offices > span');
    const collapsibleButtonIcon = document.querySelector('.show-more-offices > i');
    const defaultButtonText = collapsibleButtonSpan.textContent;

    collapsibleContainer.addEventListener('show.bs.collapse', () => {
      collapsibleButtonSpan.innerText = 'Show less';
      collapsibleButtonIcon.className = 'fal icon-angle-up ms-1';
    });

    collapsibleContainer.addEventListener('hide.bs.collapse', () => {
      collapsibleButtonSpan.innerText = defaultButtonText;
      collapsibleButtonIcon.className = 'fal icon-angle-down ms-1';
    });
  }
});
